function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4259 19.5703H3.44531C3.17188 19.5703 2.87891 19.2969 2.87891 18.9844C2.87891 18.6524 3.21094 18.3985 3.44531 18.3985H18.9532V19.0039C18.9532 19.2539 18.6798 19.5703 18.4259 19.5703Z",
  fill: "currentColor"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 18.3985C2.39063 17.8516 2.97656 17.6563 3.28906 17.6563H18.9544V0.6055C18.9544 0.273468 18.72 3.05176e-05 18.3294 3.05176e-05H3.66016C2.95703 3.05176e-05 2 0.683625 2 1.73831V18.3985ZM3.4089 8.92227H5.37655L5.78992 7.53334H7.6749L8.10481 8.92227H10.0725L7.82371 1.87841H5.65764L3.4089 8.92227ZM6.08742 6.26019H7.37714L6.74882 3.76343L6.08742 6.26019ZM12.1984 8.73445V10.421H15.2495L12.0492 14.3398V15.7783H17.6373V14.0918H14.5862L17.5875 10.173V8.73445H12.1984Z",
  fill: "currentColor"
});
function SvgGlossary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlossary);
export default __webpack_public_path__ + "static/media/glossary.5364f5486c24bcbe15ea1d4a16d66c0e.svg";
export { ForwardRef as ReactComponent };